/**
 * Подписи секции «Аудит»: период, время записи и границы окна. Вынесены из разметки,
 * чтобы их можно было проверить тестом (время зависит от часового пояса, и правило
 * форматирования должно быть одно).
 */
import { AUDIT_PERIODS, AUDIT_SCREEN_LIMIT, type AuditPeriod, type AuditScreen } from '../shared/audit';

/** Подпись периода: «За день» / «За неделю». */
export function auditPeriodTitle(period: AuditPeriod): string {
  return AUDIT_PERIODS.find((item) => item.value === period)?.label ?? period;
}

/** Двузначное число с ведущим нулём: 09, а не 9. */
function pad(value: number): string {
  return String(value).padStart(2, '0');
}

/**
 * Время записи в местном времени пользователя: «21.10.2026, 16:30:05». Формат
 * собирается вручную, а не через `toLocaleString`: так он одинаков в браузерах и
 * тестах, а журнал читают по секундам.
 */
export function formatAuditTime(iso: string): string {
  const date = new Date(iso);
  if (Number.isNaN(date.getTime())) return iso;
  return (
    `${pad(date.getDate())}.${pad(date.getMonth() + 1)}.${date.getFullYear()}, ` +
    `${pad(date.getHours())}:${pad(date.getMinutes())}:${pad(date.getSeconds())}`
  );
}

/** Границы окна одной строкой: «20.10.2026, 16:30:05 — 21.10.2026, 16:30:05». */
export function auditRangeText(screen: AuditScreen): string {
  return `${formatAuditTime(screen.from)} — ${formatAuditTime(screen.to)}`;
}

/**
 * Сколько записей показано: при превышении лимита честно пишем, что таблица неполная —
 * иначе «500 строк» читались бы как «столько всего и было».
 */
export function auditTotalText(screen: AuditScreen): string {
  if (screen.total === 0) return 'За выбранный период записей нет.';
  if (screen.truncated) {
    return `Показаны последние ${AUDIT_SCREEN_LIMIT} из ${screen.total} записей периода.`;
  }
  return `Записей за период: ${screen.total}.`;
}
